import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const ATTENTION_KEY_SEGMENT = 'attention';

/**
 * Pod korzeniem wyjazdu, obok kluczy dashboardu — hooki `tourConfig` zmiatają
 * `toursApiQueryKeys.all()` prefiksowo, więc zmiana limitu odświeży sprawy
 * bez osobnego wpisu.
 */
export const tourAttentionApiQueryKeys = {
  byTourId: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, ATTENTION_KEY_SEGMENT] as const,
};
